import React from "react";

export default function Footer() {
  return (
    <div className="container-fluid footer">
      <h3>
        Thanks for visiting! <i className="ri-user-smile-line"></i>
      </h3>

      <br />
      <h6>
        Got questions, comments, or feedback? <br />
        Feel free to reach out and contact me.
      </h6>

      <br />
      <h6 className="footertext ">© Anshul Gora - All Rights Reserved.</h6>
    </div>
  );
}
